<script>
import { required, requiredIf, email } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

// Custom Components and variables OR method
import Map from "@/components/Map.vue";
import DataUpdateInfo from "@/components/dataUpdateInfo.vue";
import { authComputed, authMethods } from "@/state/helpers";
import pbxService from "@/helpers/APIService/pbx.service";

import {
  currency,
  time_zones,
  date_formate,
  time_formate,
  date_time_formate,
} from "@/helpers/global.variable";
import Middleware from "@/helpers/middlewares";
import superService from "@/helpers/APIService/super.service";
import PbxService from "@/helpers/APIService/pbx.service";
import errorHandler from "@/helpers/errorHandler";

const initHotelForm = {
  name: "",
  brand: "",
  currency: "usd",
  address: "",
  zip_code: "",
  city: "",
  state: "",
  country: "",
  email: "",
  phone_number: "",
  front_desk_number: "",
  whatsapp_number: "",
  sms_number: "",
  website: "",
  time_zone: "America/New_York",
  date_format: { text: "MMM-DD-YYYY", value: "MMM-DD-YYYY" },
  time_formate: { text: "HH:MM XM", value: "HH:MM XM" },
  date_time_format: {
    text: "MMM-DD-YYYY HH:MM XM",
    value: "MMM-DD-YYYY HH:MM XM",
  },
  check_in_time: "03:00",
  check_out_time: "11:00",
  early_check_in_time: "07:00",
  late_check_out_time: "15:00",
  app_theme_color: "",
  latitude: "",
  longitude: "",
  map_location_url: "",
  rating: "",
  stripe_customer_id: "",
  manager_designation: "",
  manager_email: "",
  manager_name: "",
  manager_number: "",
  is_active: true,
  is_bulk_vs_sms_enable: false,
  is_chatbot_booking_support: false,
  is_guest_code_app_user: false,
  is_guest_code_enable: false,
  is_iot_master_connection: false,
  is_mobile_key_support: false,
  is_smtp2go_email_enable: false,
  is_wifi_service: false,
};

export default {
  data() {
    return {
      hotel_form: {},
      logo: {
        file: null,
        url: "",
        imgURL: "",
      },
      favicon_icon: {
        file: null,
        url: "",
        imgURL: "",
      },
      phone_number_iso: "",
      front_desk_number_iso: "",
      whatsapp_number_iso: "",
      sms_number_iso: "",
      manager_number_iso: "",
      timeZoneOptions: time_zones,
      dateFormateOptions: date_formate,
      timeFormteOptions: time_formate,
      dateTimeFormateOptions: date_time_formate,
      currencyOptions: currency,
      brandOptions: [],
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
      isDataSyncing: false,
      dataToBeUpdate: {},
      hotelFormStatus: true,

      // domain data
      pbx_form: {
        select_domain: "",
        sub_domain: "",
        pbx: "",
        ip: "",
        domain_timezone: "",
        extension_limit: "",
        domain_enabled: true,
        domain_uuid: "",
        domain_ip: "",
        domain_name: "",
        stripe_customer_id: "",
        domain_description: "",
        is_active: true,
        domain_subscription: true,
        audiomsg: false,
        audiofile: "",
        push_notification: false,
        dailyvmaildel: false,
        main_cid: "",
        emr_cid: "",
        vpn_ip: "",
      },
      tab_domain: "new-domain",
      main_domain: { text: "cloudext.co", value: "cloudext.co" },
      designation: ["Manager", "Owner"],
      ip_whitelisted: "--",
      select_domain_options: [],
      select_domain_options_copy: [],
      pbx_options: [],
      brandList: [],
      hotelID: "",
      domainLoading: false,
    };
  },
  components: {
    Map,
    DataUpdateInfo,
    VueDropify,
    VueCropper,
    DatePicker,
    Multiselect,
  },
  validations: {
    hotel_form: {
      name: { required },
      brand: { required },
      currency: { required },
      email: { required, email },
      front_desk_number: { required },
    },

    pbx_form: {
      select_domain: { required },
      pbx: { required },
      domain_uuid: {
        required: requiredIf(function () {
          if (this.tab_domain !== "new-domain") {
            return true;
          }
        }),
      },
      domain_timezone: { required },
      // domain_ip: { required },
      // domain_name: { required },
      extension_limit: { required },
    },
  },
  props: {
    hotelDetails: Object,
    isEdit: Boolean,
    pbxForm: Object,
    hotelId: String,
  },
  emits: ["cancelSubmit", "submitted"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getBrandedData();
    this.getHotel();
    this.setValue();
  },
  methods: {
    ...authMethods,
    // Method is use for get hotel details
    getHotel() {
      console.log(this.hotelDetails, "hotelDetails", this.pbxForm);
      if (this.isEdit && this.hotelDetails !== null) {
        this.dataToBeUpdate = {
          created_by: this.hotelDetails.created_by,
          created_at: this.hotelDetails.created_at,
          updated_by: this.hotelDetails.updated_by,
          updated_at: this.hotelDetails.updated_at,
        };
        Object.keys(this.hotelDetails).map((key) => {
          if (key == "favicon_icon") {
            this.favicon_icon.url = this.hotelDetails[key];
          }
          if (key == "logo") {
            this.logo.url = this.hotelDetails[key];
          }
          if (
            this.hotelDetails[key] !== null &&
            this.hotelDetails[key] !== undefined
          ) {
            this.hotel_form[key] = this.hotelDetails[key];
          }
          if (key == "brand") {
            this.hotel_form[key] = {
              value: this.hotelDetails[key].id,
              text: this.hotelDetails[key].name,
            };
          }
          if (key == "date_format") {
            this.hotel_form[key] = {
              value: this.hotelDetails[key],
              text: this.hotelDetails[key],
            };
          }
          if (key == "date_time_format") {
            this.hotel_form[key] = {
              value: this.hotelDetails[key],
              text: this.hotelDetails[key],
            };
          }
          if (key == "time_formate") {
            this.hotel_form[key] = {
              value: this.hotelDetails[key],
              text: this.hotelDetails[key],
            };
          }
        });
      } else {
        this.hotel_form = initHotelForm;
      }
    },
    // Method is use for submit updated hotel details
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.isError = false;
      this.$v.hotel_form.$touch();
      if (this.$v.hotel_form.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let hotelData = new FormData();
        delete this.hotel_form.favicon_icon;
        delete this.hotel_form.logo;
        this.hotel_form.brand = this.hotel_form.brand.value;
        this.hotel_form.date_format = this.hotel_form.date_format.value;
        this.hotel_form.time_formate = this.hotel_form.time_formate.value;
        this.hotel_form.date_time_format =
          this.hotel_form.date_time_format.value;
        Object.keys(this.hotel_form).map((key) => {
          if (
            this.hotel_form[key] !== null &&
            this.hotel_form[key] !== undefined
          ) {
            if (this.isEdit) {
              if (this.hotel_form[key] !== this.hotelDetails[key])
                hotelData.append(key, this.hotel_form[key]);
            } else {
              hotelData.append(key, this.hotel_form[key]);
            }
          }
        });
        if (this.logo.file != null || "") {
          hotelData.append(
            "logo",
            this.createImageFromBase(
              this.$refs.cropper.getCroppedCanvas().toDataURL(),
              "logo.jpg"
            )
          );
        }
        if (this.favicon_icon.file != null || "") {
          hotelData.append(
            "favicon_icon",
            this.createImageFromBase(
              this.$refs.cropper.getCroppedCanvas().toDataURL(),
              "favicon_icon.jpg"
            )
          );
        }
        if (this.phone_number_iso !== "")
          hotelData.append("phone_number_iso", this.phone_number_iso);
        if (this.front_desk_number_iso !== "")
          hotelData.append("front_desk_number_iso", this.front_desk_number_iso);
        if (this.front_desk_number_iso !== "")
          hotelData.append("front_desk_number_iso", this.front_desk_number_iso);
        if (this.sms_number_iso !== "")
          hotelData.append("sms_number_iso", this.sms_number_iso);
        if (this.isEdit) {
          superService
            .updateHotel(this.hotelDetails.id, hotelData)
            .then((response) => {
              this.isBtnLoading = false;
              Middleware.notification(
                "Hotel updated successfully !!",
                "success"
              );
              // this.$emit("submitted", response);
              this.hotelID = response.id;
              this.hotelFormStatus = false;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              this.hotel_form = initHotelForm;
              errorHandler(error);
              if (error.response.status !== 500) {
                this.isError = true;
                this.errorMessage = error.response.data;
              }
            });
        } else {
          superService
            .addHotel(hotelData)
            .then((response) => {
              this.isBtnLoading = false;
              Middleware.notification("Hotel added successfully !!", "success");
              // this.$emit("submitted", response);
              this.hotelID = response.id;
              this.hotelFormStatus = false;

              // this.hotel_form = initHotelForm;
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
              if (error.response.status !== 500) {
                this.isError = true;
                this.errorMessage = error.response.data;
              }
            });
        }
      }
    },
    // Method is used to cancel form submission
    cancelSubmition() {
      this.hotel_form = initHotelForm;
      this.$emit("cancelSubmit");
    },
    // Method is use for update and maintained favicon icon
    changeFavicon(event) {
      if (event[0] !== undefined) {
        this.favicon_icon.file = event[0] == undefined ? null : event[0];
        this.favicon_icon.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.favicon_icon.file = null;
        this.favicon_icon.url = "";
        this.favicon_icon.imgURL = "";
      }
    },
    // Method is use for update and maintained logo icon
    changeLogo(event) {
      if (event[0] !== undefined) {
        this.logo.file = event[0] == undefined ? null : event[0];
        this.logo.imgURL = URL.createObjectURL(event[0]);
      } else {
        this.logo.file = null;
        this.logo.url = "";
        this.logo.imgURL = "";
      }
    },
    // Method is use for maintained and mange country change
    countryChange(phone_type, code) {
      switch (phone_type) {
        case "phone_number":
          this.phone_number_iso = code.iso2;
          break;
        case "front_desk_number":
          this.front_desk_number_iso = code.iso2;
          break;
        case "whatsapp_number":
          this.whatsapp_number_iso = code.iso2;
          break;
        case "manager_number":
          this.manager_number_iso = code.iso2;
          break;
        case "sms_number":
          this.sms_number_iso = code.iso2;
          break;
      }
    },
    // Method is used to get brand list data
    async getBrandedData() {
      this.isDataLoading = true;
      try {
        const brands = await superService.getBrandData();
        if (brands) {
          this.brandList = brands;
          brands.map((brand) => {
            this.brandOptions.push({ text: brand.name, value: brand.id });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is use for convert base64 file into file
    createImageFromBase(dataUrl, filename) {
      var arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    // Method is used to sync near by places
    async syncNearByPlaceRecord(hotel_id) {
      if (this.isDataSyncing)
        return Middleware.notification(
          "Syncing other place, please try after some time !!",
          "info"
        );
      try {
        this.isDataSyncing = true;
        const response = await superService.getNearByPlaces(hotel_id);
        if (response) {
          Middleware.notification(
            "It's take upto 5 to 7 minutes to sync nearby places !!",
            "info"
          );
          setTimeout(() => {
            this.isDataSyncing = false;
          }, 50000);
        }
      } catch (error) {
        this.isDataSyncing = false;
        errorHandler(error);
      }
    },
    // Method is used to handle search result
    async setPlace(place) {
      let forDetails = [];
      let googleData = place;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      googleData = { ...googleData, latitude: lat, longitude: lng };
      if (place.formatted_address) {
        this.hotel_form.address = place.formatted_address;
      }
      for (
        let index = 0;
        index < googleData.address_components.length;
        index++
      ) {
        const element = googleData.address_components[index];
        forDetails.push(element);
      }

      // To get Location Details like city, state, country etc.
      for (let index = 0; index < forDetails.length; index++) {
        const element = forDetails[index];
        if (element.types[0] == "country") {
          this.hotel_form.country = element.long_name;
        }
        if (element.types[0] == "administrative_area_level_1") {
          this.hotel_form.state = element.short_name;
        }
        if (element.types[0] == "administrative_area_level_2") {
          this.hotel_form.city = element.long_name;
        } else if (element.types[0] == "administrative_area_level_3") {
          this.hotel_form.city = element.long_name;
        }
        if (element.types[0] == "locality") {
          this.hotel_form.address = element.long_name;
        }
        if (element.types[0] == "postal_code") {
          this.hotel_form.zip_code = element.long_name;
        }
      }

      this.hotel_form.latitude = googleData.latitude;
      this.hotel_form.longitude = googleData.longitude;
      this.hotel_form.front_desk_number = googleData.international_phone_number
        ? googleData.international_phone_number
        : "";
      this.hotel_form.name = googleData.name ? googleData.name : "";
      this.hotel_form.website = googleData.website ? googleData.website : "";
      this.hotel_form.rating = Math.floor(googleData.rating);
      this.hotel_form.map_location_url = googleData.url;
    },

    brandChange(brand) {
      console.log(brand, "brand");
      this.brandList.forEach((element) => {
        if (brand.value == element.id) {
          this.logo.imgURL = element.logo;
          this.favicon_icon.imgURL = element.favicon_icon;
        }
      });
    },

    // domain methods
    // Method is used to get Domain list
    async setValue() {
      try {
        const response = await PbxService.getDomainList();
        if (response) {
          response.forEach((element) => {
            this.select_domain_options_copy.push({
              value: element.domain_uuid,
              text: element.domain_name,
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
      // Method is used to get Pbx Server List
      try {
        const pbxresponse = await PbxService.getPBXServerList();
        pbxresponse.result.forEach((element) => {
          this.pbx_options.push({
            value: element.server_ip,
            text: element.server_name,
            item: element,
          });
        });
        this.domainLoading = false;
        if (this.hotelDetails !== null) {
          if (this.hotelDetails.pbx_domain_uuid) {
            const response = await pbxService.getDomainDetailList(
              this.hotelDetails.pbx_domain_uuid
            );
            this.pbxForm = response;
          } else {
            this.pbxForm = null;
          }
        } else {
          this.pbxForm = null;
        }
        if (
          this.isEdit &&
          this.pbxForm !== null &&
          this.pbxForm !== undefined
        ) {
          this.select_domain_options = this.select_domain_options_copy;
          this.tab_domain = "existing-domain";
          this.update_domain(this.pbxForm.domain_uuid);
        } else {
          this.pbx_form.select_domain = this.main_domain;
          this.select_domain_options = [
            { text: "cloudext.co", value: "cloudext.co" },
          ];
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // On domain select
    onChange(event) {
      if (event == "new-domain") {
        Object.keys(this.pbx_form).map((key) => {
          if (this.pbx_form[key] !== null && this.pbx_form[key] !== undefined) {
            this.pbx_form[key] = "";
          }
        });
        this.select_domain_options = [
          { text: "cloudext.co", value: "cloudext.co" },
        ];
        this.pbx_form.select_domain = this.main_domain;
      } else {
        this.select_domain_options = this.select_domain_options_copy;
      }
    },
    // Select Domain And Update input filed
    update_domain(domain_uuid) {
      if (domain_uuid == undefined) return;
      this.domainLoading = true;
      let domainId =
        typeof domain_uuid == "string" ? domain_uuid : domain_uuid.value;
      PbxService.getDomainDetailList(domainId)
        .then((res) => {
          this.domainLoading = false;
          this.pbx_form = res;
          this.pbx_form.domain_ip = res.ip;
          this.pbx_form.pbx = { text: res.pbx, value: res.ip };
          this.pbx_form.extension_limit = res.extension_limit;
          this.pbx_form.select_domain = {
            value: res.domain_uuid,
            text: res.domain_name,
          };
        })
        .catch((error) => {
          this.domainLoading = false;
          errorHandler(error);
        });
    },
    // Select PBX Server And Update input filed
    update_server() {
      let pbxobj = this.pbx_form.pbx;
      this.pbx_options.forEach((element) => {
        if (pbxobj.value == element.value) {
          this.pbx_form.ip = element.item.server_ip;
        }
      });
      if (this.isEdit == false && this.tab_domain == "new-domain") {
        this.pbx_form.domain_name =
          this.pbx_form.sub_domain + "." + this.pbx_form.select_domain.value;
      }
    },
    // Method is used to handle submit form
    onDomainSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.pbx_form.$touch();
      if (this.$v.pbx_form.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        if (this.tab_domain == "new-domain") {
          const domain_name =
            this.pbx_form.sub_domain + "." + this.pbx_form.select_domain.value;
          const data = {
            domain_name: domain_name,
            domain_enabled: this.pbx_form.domain_enabled,
            domain_description: this.pbx_form.domain_description,
            pbx: this.pbx_form.pbx.text,
            ip: this.pbx_form.ip,
            domain_timezone: this.pbx_form.domain_timezone,
            stripe_customer_id: this.pbx_form.stripe_customer_id,
            domain_subscription:
              this.pbx_form.domain_subscription == true ? "active" : "",
            main_cid: this.pbx_form.main_cid,
            emr_cid: this.pbx_form.emr_cid,
            vpn_ip: this.pbx_form.vpn_ip,
            audiomsg: this.pbx_form.audiomsg,
            audiofile: this.pbx_form.audiofile,
            dailyvmaildel: this.pbx_form.dailyvmaildel,
            staffauth: "",
            // roomblock: this.pbx_form.roomblock,
            vm_admin_pin: this.pbx_form.vm_admin_pin,
            extension_limit: this.pbx_form.extension_limit,
          };
          PbxService.addDomainDetail(data)
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "danger");
              }
              superService.updateHotel(this.hotelID, {
                pbx_domain_name: response.result.domain_name,
                pbx_domain_uuid: response.result.domain_uuid,
              });
              Middleware.notification(
                " Domain successfully updated !!",
                "success"
              );
              this.$emit("submitted", "submitted");
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          let pbx_domain_uuid =
            typeof this.pbx_form.select_domain == "string"
              ? this.pbx_form.select_domain
              : this.pbx_form.select_domain.value;
          superService
            .updateHotel(this.hotelID, {
              pbx_domain_name: this.pbx_form.domain_name,
              pbx_domain_uuid: pbx_domain_uuid,
            })
            .then((response) => {
              this.isBtnLoading = false;
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              this.$emit("submitted", "submitted");
              Middleware.notification(
                " Domain successfully updated !!",
                "success"
              );
            })
            .catch((error) => {
              this.isError = true;
              this.isBtnLoading = false;
              this.errorMessage = error.response.data;
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row" v-show="hotelFormStatus">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between">
          <h4>{{ isEdit ? "Update" : "Add" }} Hotel Details</h4>
          <b-button
            class="btn btn-sm float-end d-flex align-items-center"
            variant="primary"
            v-b-popover.hover="'sync nearby place'"
            @click="syncNearByPlaceRecord(hotelDetails.id)"
            :disabled="isDataSyncing"
          >
            Sync places
            <i
              class="mdi mdi-sync ms-2 fs-5"
              :class="isDataSyncing ? 'mdi-spin' : ''"
            ></i
          ></b-button>
        </div>
        <hr />
      </div>
      <div class="col-md-12">
        <div class="row">
          <!-- Basic Details -->
          <div class="col-md-10">
            <div class="position-relative mb-3">
              <Map class="w-100" @update:place="setPlace"></Map>
            </div>
          </div>
          <div class="col-md-12">
            <h4 class="card-title">Basic Details</h4>
            <hr />
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label-for="hotel-name-input">
              <span slot="label">
                Name <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="hotel-name-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.name"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.name.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.hotel_form.name.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.name.required">
                  Name is required.
                </span>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group class="mb-3" label-for="brand-input">
              <span slot="label">
                Brand <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="hotel_form.brand"
                :options="brandOptions"
                :show-labels="false"
                @select="brandChange($event)"
                placeholder="Search band"
                label="text"
                track-by="value"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.brand.$error,
                }"
              ></multiselect>
              <div
                v-if="submitted && $v.hotel_form.brand.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.brand.required"
                  >Brand is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="rating-input"
            >
              <span slot="label">
                Rating <span class="text-danger">*</span>
              </span>
              <div class="rating-input">
                <div class="star-rating">
                  <input
                    type="radio"
                    id="5-stars"
                    name="rating"
                    value="5"
                    v-model="hotel_form.rating"
                  />
                  <label for="5-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="4-stars"
                    name="rating"
                    value="4"
                    v-model="hotel_form.rating"
                  />

                  <label for="4-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="3-stars"
                    name="rating"
                    value="3"
                    v-model="hotel_form.rating"
                  />
                  <label for="3-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="2-stars"
                    name="rating"
                    value="2"
                    v-model="hotel_form.rating"
                  />
                  <label for="2-stars" class="star">&#9733;</label>
                  <input
                    type="radio"
                    id="1-star"
                    name="rating"
                    value="1"
                    v-model="hotel_form.rating"
                  />
                  <label for="1-star" class="star">&#9733;</label>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="currency-input"
            >
              <span slot="label">
                Currency <span class="text-danger">*</span>
              </span>
              <b-form-select
                class="form-select"
                id="currency-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.currency"
                :options="currencyOptions"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.currency.$error,
                }"
              >
              </b-form-select>
              <div
                v-if="submitted && $v.hotel_form.currency.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.currency.required"
                  >Currency is required.</span
                >
              </div>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="stripe_customer_id-input"
            >
              <span slot="label"> Strip Customer Id </span>
              <b-form-input
                id="stripe_customer_id-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.stripe_customer_id"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- Address Details -->
          <div class="col-md-12">
            <h4 class="card-title">Address Information</h4>
            <hr />
          </div>
          <div class="col-md-3">
            <b-form-group class="mb-3" label-for="address-input">
              <span slot="label"> Address </span>
              <b-form-textarea
                id="address-input"
                placeholder="Enter Address..."
                v-model="hotel_form.address"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <div class="col-md-3 col-sm-6">
            <b-form-group class="mb-3" label-for="city-input">
              <span slot="label"> City </span>
              <b-form-input
                id="city-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.city"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="state-input">
              <span slot="label"> State </span>
              <b-form-input
                id="state-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.state"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2 col-sm-6">
            <b-form-group class="mb-3" label-for="zip-code-input">
              <span slot="label"> Zip Code </span>
              <b-form-input
                id="zip-code-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.zip_code"
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="country-input">
              <span slot="label"> Country </span>
              <b-form-input
                id="country-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.country"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="latitude-input">
              <span slot="label"> Latitude </span>
              <b-form-input
                id="latitude-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.latitude"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-2 col-sm-4">
            <b-form-group class="mb-3" label-for="longitude-input">
              <span slot="label"> Longitude </span>
              <b-form-input
                id="longitude-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.longitude"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-8">
            <b-form-group class="mb-3" label-for="map_location_url-input">
              <span slot="label"> Map Location Url </span>
              <b-form-input
                id="map_location_url-input"
                type="url"
                autocomplete="off"
                v-model="hotel_form.map_location_url"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- Contact Details -->
          <div class="col-md-12">
            <h4 class="card-title">Contact Details</h4>
            <hr />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="email-input"
            >
              <span slot="label">
                FRONT DESK Email <span class="text-danger">*</span>
              </span>
              <b-form-input
                id="email-input"
                type="email"
                autocomplete="off"
                v-model="hotel_form.email"
                :class="{
                  'is-invalid': submitted && $v.hotel_form.email.$error,
                }"
              ></b-form-input>
              <div
                v-if="submitted && $v.hotel_form.email.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.hotel_form.email.required">
                  Email is required.
                </span>
                <span v-if="!$v.hotel_form.email.email">
                  Email is not valid.
                </span>
              </div>
            </b-form-group>
          </div>
          <!-- <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="form-label">Phone </label>
            <vue-tel-input class="text-dark-gray" v-model="hotel_form.phone_number" :validCharactersOnly="true"
              :defaultCountry="
                hotelDetails
                  ? hotelDetails.phone_number_iso !== null
                    ? hotelDetails.phone_number_iso
                    : 'US'
                  : 'US'
              " @country-changed="countryChange('phone_number', ...arguments)"></vue-tel-input>
          </div> -->
          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="form-label"
              >Front Desk Tel <span class="text-danger">*</span></label
            >
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.front_desk_number"
              :defaultCountry="
                hotelDetails
                  ? hotelDetails.front_desk_number_iso !== null
                    ? hotelDetails.front_desk_number_iso
                    : 'US'
                  : 'US'
              "
              :validCharactersOnly="true"
              @country-changed="
                countryChange('front_desk_number', ...arguments)
              "
              :class="{
                'is-invalid':
                  submitted && $v.hotel_form.front_desk_number.$error,
              }"
            >
            </vue-tel-input>
            <div
              v-if="submitted && $v.hotel_form.front_desk_number.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.hotel_form.front_desk_number.required"
                >Number is required.</span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="form-label">Whatsapp No</label>
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.whatsapp_number"
              :validCharactersOnly="true"
              :defaultCountry="
                hotelDetails
                  ? hotelDetails.whatsapp_number_iso !== null
                    ? hotelDetails.whatsapp_number_iso
                    : 'US'
                  : 'US'
              "
              @country-changed="countryChange('whatsapp_number', ...arguments)"
            ></vue-tel-input>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <label class="form-label">SMS No</label>
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.sms_number"
              :validCharactersOnly="true"
              :defaultCountry="
                hotelDetails
                  ? hotelDetails.sms_number_iso !== null
                    ? hotelDetails.sms_number_iso
                    : 'US'
                  : 'US'
              "
              @country-changed="countryChange('sms_number', ...arguments)"
            ></vue-tel-input>
          </div>
          <div class="col-12">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="website-input"
            >
              <span slot="label"> Website </span>
              <b-form-input
                id="website-input"
                type="url"
                autocomplete="off"
                v-model="hotel_form.website"
              ></b-form-input>
            </b-form-group>
          </div>

          <!-- Manager Details -->
          <div class="col-md-12">
            <h4 class="card-title">Manager Details</h4>
            <hr />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="name-input"
            >
              <span slot="label"> Name </span>
              <b-form-input
                id="name-input"
                type="text"
                autocomplete="off"
                v-model="hotel_form.manager_name"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="brand-input">
              <span slot="label"> Designation </span>
              <b-form-select
                class="form-select"
                id="designation-input"
                :options="designation"
                v-model="hotel_form.manager_designation"
                type="text"
                autocomplete="off"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="email-input"
            >
              <span slot="label"> Email </span>
              <b-form-input
                id="name-input"
                type="email"
                autocomplete="off"
                v-model="hotel_form.manager_email"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
            <label class="form-label">Number</label>
            <vue-tel-input
              class="text-dark-gray"
              v-model="hotel_form.manager_number"
              :validCharactersOnly="true"
              :defaultCountry="
                hotelDetails
                  ? hotelDetails.manager_number_iso !== null
                    ? hotelDetails.manager_number_iso
                    : 'US'
                  : 'US'
              "
              @country-changed="countryChange('manager_number', ...arguments)"
            ></vue-tel-input>
          </div>

          <!-- Time related Details -->
          <div class="col-md-12">
            <h4 class="card-title">Time zone Information</h4>
            <hr />
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-zone-input"
            >
              <span slot="label"> Time Zone </span>
              <b-form-select
                class="form-select"
                id="time-zone-input"
                :options="timeZoneOptions"
                v-model="hotel_form.time_zone"
                type="text"
                autocomplete="off"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="date-formate-input"
            >
              <span slot="label"> Date Format </span>
              <multiselect
                :options="dateFormateOptions"
                v-model="hotel_form.date_format"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                id="date-formate-input"
              ></multiselect>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-formate-input"
            >
              <span slot="label"> Time Formate </span>
              <multiselect
                :options="timeFormteOptions"
                v-model="hotel_form.time_formate"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                id="time-formate-input"
              ></multiselect>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="date-time-formate-input"
            >
              <span slot="label"> Date Time Format </span>
              <multiselect
                :options="dateTimeFormateOptions"
                v-model="hotel_form.date_time_format"
                :show-labels="false"
                placeholder="Search band"
                label="text"
                track-by="value"
                id="date-time-formate-input"
              ></multiselect>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="check-in-time-input">
              <span slot="label"> Check In Time </span>
              <date-picker
                lang="en"
                placeholder="HH:mm"
                v-model="hotel_form.check_in_time"
                type="time"
                value-type="HH:mm"
                :clearable="false"
                :timePickerOptions="{
                  start: '00:00:00',
                  step: '00:15:00',
                  end: '23:30:00',
                  format: 'HH:mm',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="check-out-time-input">
              <span slot="label"> Check Out Time </span>
              <date-picker
                lang="en"
                placeholder="HH:mm"
                v-model="hotel_form.check_out_time"
                type="time"
                value-type="HH:mm"
                :clearable="false"
                :timePickerOptions="{
                  start: '00:00:00',
                  step: '00:15:00',
                  end: '23:30:00',
                  format: 'HH:mm',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="early-check-in-time-input">
              <span slot="label"> Early Check In time </span>
              <date-picker
                lang="en"
                placeholder="HH:mm"
                v-model="hotel_form.early_check_in_time"
                type="time"
                value-type="HH:mm"
                :clearable="false"
                :timePickerOptions="{
                  start: '00:00:00',
                  step: '00:15:00',
                  end: '23:30:00',
                  format: 'HH:mm',
                }"
              ></date-picker>
            </b-form-group>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-6">
            <b-form-group class="mb-3" label-for="late-checkout-time-input">
              <span slot="label"> Late Check Out Time </span>
              <date-picker
                lang="en"
                placeholder="HH:mm"
                v-model="hotel_form.late_check_out_time"
                type="time"
                :clearable="false"
                value-type="HH:mm"
                :timePickerOptions="{
                  start: '00:00:00',
                  step: '00:15:00',
                  end: '23:30:00',
                  format: 'HH:mm',
                }"
              ></date-picker>
            </b-form-group>
          </div>

          <!-- Permissions related Details -->
          <div class="col-md-12">
            <h4 class="card-title">Permission Details</h4>
            <hr />
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="is_chatbot_booking_support"
                >Chatbot support booking</label
              >
              <div
                class="form-check form-switch my-1"
                slot="is_chatbot_booking_support"
              >
                <input
                  class="form-check-input"
                  id="is_chatbot_booking_support"
                  type="checkbox"
                  v-model="hotel_form.is_chatbot_booking_support"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="cloudext">CloudExt</label>
              <div class="form-check form-switch my-1" slot="cloudext">
                <input
                  class="form-check-input"
                  id="cloudext"
                  type="checkbox"
                  v-model="hotel_form.cloudext"
                />
              </div>
            </div>
          </div>

          <!-- Other Details -->
          <div class="col-md-12">
            <h4 class="card-title">Other Details</h4>
            <hr />
          </div>
          <div class="col-md-6">
            <label for="logo" class="form-label">Logo</label>
            <VueDropify
              v-if="logo.imgURL == ''"
              @upload="changeLogo($event)"
              :src="logo.url"
              message="Drop image here or click to select"
              class="w-100"
            />
            <vue-cropper
              v-else
              ref="cropper"
              :src="logo.imgURL"
              alt="Source Image"
              class="position-relative w-100"
              :minCropBoxWidth="200"
              :minCropBoxHeight="200"
            >
            </vue-cropper>
          </div>
          <div class="col-md-6">
            <label for="favicon" class="form-label">Favicon</label>
            <VueDropify
              v-if="favicon_icon.imgURL == ''"
              @upload="changeFavicon($event)"
              :src="favicon_icon.url"
              message="Drop image here or click to select"
            />
            <vue-cropper
              v-else
              ref="cropper"
              :src="favicon_icon.imgURL"
              alt="Source Image"
              class="position-relative w-100"
              :minCropBoxWidth="200"
              :minCropBoxHeight="200"
            >
            </vue-cropper>
          </div>
          <div class="col-lg-3 col-md-4 col-sm-5 col-7">
            <div class="d-flex align-items-center mt-3">
              <b-form-input
                class="form-control-color me-2 w-25"
                id="theam_color"
                type="color"
                name="theam_color"
                v-model="hotel_form.app_theme_color"
              ></b-form-input>

              <b-form-input
                class="form-control-color form-color-input w-100"
                id="theam_color"
                type="text"
                v-model="hotel_form.app_theme_color"
              ></b-form-input>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              {{ index }}: {{ error[0] }}
            </li>
          </ul>
        </b-alert>
      </div>
      <div class="col-md-12">
        <b-button
          variant="primary"
          class="float-end ms-2 mb-3"
          type="reset"
          @click="cancelSubmition()"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="float-end mb-3"
          type="submit"
          :class="{ disabled: isBtnLoading }"
          @click="onSubmit"
        >
          <i
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            v-if="isBtnLoading"
          ></i>
          {{ this.isEdit ? "Next" : "Next" }}
        </b-button>
      </div>
      <DataUpdateInfo :data-to-be-show="dataToBeUpdate" />
    </div>

    <div v-show="!hotelFormStatus">
      <b-form @submit.prevent="onDomainSubmit">
        <div class="row">
          <!-- Domain Details -->
          <h4 class="card-title">
            Domain Details
            <b-spinner
              v-if="domainLoading"
              class="ms-2"
              small
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </h4>
          <hr />
          <div class="col-md-12">
            <b-form-group class="mb-3" label-for="pbx_serve">
              <span slot="label">
                Create Customer With <span class="text-danger">*</span>
              </span>
              <div class="row">
                <div class="col-md-2">
                  <b-form-radio
                    v-model="tab_domain"
                    name="new_domain"
                    value="new-domain"
                    @change="onChange($event)"
                  >
                    <span class="ms-2"> New Domain </span>
                  </b-form-radio>
                </div>
                <div class="col-3">
                  <b-form-radio
                    v-model="tab_domain"
                    name="existing_domain"
                    value="existing-domain"
                    @change="onChange($event)"
                  >
                    <span class="ms-2"> Existing Domain </span>
                  </b-form-radio>
                </div>
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="select-domain">
              <span slot="label">
                <span v-if="tab_domain == 'new-domain'">Select </span> Domain
                <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="pbx_form.select_domain"
                :options="select_domain_options"
                @input="update_domain"
                :show-labels="false"
                placeholder="Search Domain"
                label="text"
                track-by="value"
                id="select-domain"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.select_domain.$error,
                }"
              ></multiselect>
              <div
                v-if="submitted && $v.pbx_form.select_domain.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.select_domain.required"
                  >Select Domain is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4" v-if="tab_domain == 'new-domain'">
            <b-form-group class="mb-3" label-for="sub_domain">
              <span slot="label">
                Sub Domain Name <span class="text-danger">*</span></span
              >
              <div class="row mx-1 align-items-end">
                <b-form-input
                  id="sub_domain"
                  type="text"
                  autocomplete="off"
                  v-model="pbx_form.sub_domain"
                  class="col-auto"
                ></b-form-input>
                <span class="col-auto text-dark"
                  >.{{ pbx_form.select_domain ? "cloudext.co" : "" }}</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="select-server">
              <span slot="label">
                Select Server <span class="text-danger">*</span>
              </span>
              <multiselect
                v-model="pbx_form.pbx"
                :options="pbx_options"
                @input="update_server"
                :show-labels="false"
                placeholder="Search Server"
                label="text"
                track-by="value"
                id="select-server"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.pbx.$error,
                }"
              ></multiselect>

              <div
                v-if="submitted && $v.pbx_form.pbx.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.pbx_form.pbx.required"
                  >Select Server is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label">
                <span v-if="tab_domain == 'new-domain'">Server </span> Ip
                <span class="text-danger">*</span></span
              >
              <b-form-input
                id="ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.ip"
                readonly
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label-for="time-zone-input"
            >
              <span slot="label"> Timezone </span>
              <b-form-select
                class="form-select"
                id="time-zone-input"
                :options="timeZoneOptions"
                v-model="pbx_form.domain_timezone"
                type="text"
                autocomplete="off"
              ></b-form-select>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_form.domain_timezone.required"
                  >Time Zone is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="extension_limit">
              <span slot="label">
                Extension Limit <span class="text-danger">*</span></span
              >
              <b-form-input
                id="extension_limit"
                type="number"
                autocomplete="off"
                v-model="pbx_form.extension_limit"
                :class="{
                  'is-invalid': submitted && $v.pbx_form.extension_limit.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.pbx_form.extension_limit.required"
                  >Extension Limit is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <!-- <div class="col-md-2">
            <div class="mb-3">
              <label for="domain_enabled">Domain Enabled</label>
              <div class="form-check form-switch my-1" slot="domain_enabled">
                <input class="form-check-input" id="domain_enabled" type="checkbox" v-model="pbx_form.domain_enabled" />
              </div>
            </div>
          </div> -->
          <!-- <div class="col-md-8">
            <div class="mb-3">
              <label for="ip_whitelisted">IP Whitelisted in Firewall:</label>
              <h6>{{ ip_whitelisted }}</h6>
            </div>
          </div> -->

          <!-- Basic Details -->
          <!-- <h4 class="card-title">Basic Details</h4>
          <hr /> -->

          <!-- <div class="col-md-4">
            <b-form-group class="mb-3" label-for="domain_name">
              <span slot="label">
                Domain Name <span class="text-danger">*</span></span>
              <b-form-input id="domain_name" type="text" autocomplete="off" v-model="pbx_form.domain_name" :class="{
                'is-invalid': submitted && $v.pbx_form.domain_name.$error,
              }"></b-form-input>
              <div v-if="submitted && $v.pbx_form.domain_name.$error" class="invalid-feedback">
                <span v-if="!$v.pbx_form.domain_name.required">Domain Name is required.</span>
              </div>
            </b-form-group>
          </div> -->
          <!-- <div class="col-md-4">
            <b-form-group class="mb-3" label-for="domain_uuid">
              <span slot="label">
                Domain UUID
                <span class="text-danger" v-if="tab_domain !== 'new-domain'">*</span></span>
              <b-form-input id="domain_uuid" type="text" autocomplete="off" v-model="pbx_form.domain_uuid" :class="{
                'is-invalid': submitted && $v.pbx_form.domain_uuid.$error,
              }"></b-form-input>
              <div v-if="submitted && $v.pbx_form.domain_uuid.$error" class="invalid-feedback">
                <span v-if="!$v.pbx_form.domain_uuid.required">Domain is required.</span>
              </div>
            </b-form-group>
          </div> -->
          <!-- <div class="col-md-4">
            <b-form-group class="mb-3" label-for="ip">
              <span slot="label">
                Domain Ip <span class="text-danger">*</span></span>
              <b-form-input id="ip" type="text" autocomplete="off" v-model="pbx_form.domain_ip" :class="{
                'is-invalid': submitted && $v.pbx_form.domain_ip.$error,
              }"></b-form-input>
              <div v-if="submitted && $v.pbx_form.domain_ip.$error" class="invalid-feedback">
                <span v-if="!$v.pbx_form.domain_ip.required">Domain Ip is required.</span>
              </div>
            </b-form-group>
          </div> -->
          <!-- <div class="col-md-4">
            <b-form-group class="mb-3" label-for="stripe_customer_id">
              <span slot="label"> Strip Id </span>
              <b-form-input id="stripe_customer_id" type="text" autocomplete="off"
                v-model="pbx_form.stripe_customer_id"></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <div class="mb-3">
              <label for="is_active">Active</label>
              <div class="form-check form-switch my-1" slot="is_active">
                <input class="form-check-input" id="is_active" type="checkbox" v-model="pbx_form.is_active" />
              </div>
            </div>
          </div> -->
          <!-- <div class="col-md-2">
            <div class="mb-3">
              <label for="domain_subscription" v-b-popover.hover.top="'Domain Subscription'">Domain Subscription</label>
              <div class="form-check form-switch my-1" slot="domain_subscription">
                <input class="form-check-input" id="domain_subscription" type="checkbox"
                  v-model="pbx_form.domain_subscription" />
              </div>
            </div>
          </div> -->
          <div class="col-md-8">
            <b-form-group class="mb-3" label-for="address-input">
              <span slot="label"> Description </span>
              <b-form-textarea
                id="description"
                v-model="pbx_form.domain_description"
              ></b-form-textarea>
            </b-form-group>
          </div>

          <!-- Default Settings -->
          <h4 class="card-title">Default Settings</h4>
          <hr />

          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="main_cid">
              <span slot="label"> Outbound Caller ID</span>
              <b-form-input
                id="main_cid"
                type="number"
                autocomplete="off"
                v-model="pbx_form.main_cid"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="main_cid">
              <span slot="label"> Outbound Caller Name</span>
              <b-form-input
                id="main_cid"
                type="text"
                autocomplete="off"
                v-model="pbx_form.main_cid"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="emr_cid">
              <span slot="label"> Emergency Caller ID </span>
              <b-form-input
                id="emr_cid"
                type="number"
                autocomplete="off"
                v-model="pbx_form.emr_cid"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5">
            <b-form-group class="mb-3" label-for="emr_cid">
              <span slot="label"> Emergency Caller Name </span>
              <b-form-input
                id="emr_cid"
                type="text"
                autocomplete="off"
                v-model="pbx_form.emr_cid"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="vpn_ip">
              <span slot="label"> VPN IP </span>
              <b-form-input
                id="vpn_ip"
                type="text"
                autocomplete="off"
                v-model="pbx_form.vpn_ip"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="vm_admin_pin">
              <span slot="label"> Admin Pin </span>
              <b-form-input
                id="vm_admin_pin"
                type="text"
                autocomplete="off"
                v-model="pbx_form.vm_admin_pin"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label
                for="dailyvmaildel"
                v-b-popover.hover.top="'Daily VoiceMail Delete'"
                >Daily VoiceMail Delete</label
              >
              <div class="form-check form-switch my-1" slot="dailyvmaildel">
                <input
                  class="form-check-input"
                  id="dailyvmaildel"
                  type="checkbox"
                  v-model="pbx_form.dailyvmaildel"
                />
              </div>
            </div>
          </div>

          <!-- Voice Message Advertisement -->
          <!-- <h4 class="card-title">Voice Message Advertisement</h4>
          <hr />

          <div class="col-md-4">
            <b-form-group class="mb-3" label-for="audiofile">
              <span slot="label"> Audio File </span>
              <b-form-select class="form-select" id="time-zone-input" v-model="pbx_form.audiofile" type="text"
                autocomplete="off">
                <b-form-select-option value="npport">No Port</b-form-select-option>
                <b-form-select-option value="nppay">No Pay</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="audiomsg" v-b-popover.hover.top="'Audio Message'">Audio Message</label>
              <div class="form-check form-switch my-1" slot="audiomsg">
                <input class="form-check-input" id="audiomsg" type="checkbox" v-model="pbx_form.audiomsg" />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <label for="push_notification" v-b-popover.hover.top="'Mobile Push Notification'">Mobile Push
                Notification</label>
              <div class="form-check form-switch my-1" slot="push_notification">
                <input class="form-check-input" id="push_notification" type="checkbox"
                  v-model="pbx_form.push_notification" />
              </div>
            </div>
          </div> -->

          <div class="col-md-12">
            <b-alert v-if="isError" show variant="danger">
              <ul>
                <li v-for="(error, index) in errorMessage" :key="index">
                  {{ index }}: {{ error[0] }}
                </li>
              </ul>
            </b-alert>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              :class="{
                disabled: isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isBtnLoading"
              ></i>
              {{ this.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<style>
.star-rating {
  display: flex;
  flex-direction: row-reverse;
  font-size: 1.5em;
  justify-content: space-between;
  text-align: center;
}

.star-rating input {
  display: none;
}

.star-rating label {
  color: #ccc;
  cursor: pointer;
  margin: 0;
  font-size: 40px;
  line-height: 0.8;
}

.star-rating :checked ~ label {
  color: #fc0;
}

.star-rating label:hover,
.star-rating label:hover ~ label {
  color: #f90;
}
</style>
